<template>
  <v-dialog
    v-model="value"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @keydown.esc="$emit('input', false)"
  >
    <CreditNoteForm
      v-if="value"
      :creditNoteId="creditNoteId"
      :projectId="projectId"
      :marketId="marketId"
      :type="type"
      @onSaveSuccess="onSaveSuccess"
      @onDismiss="dismiss"
    />
  </v-dialog>
</template>
<script>
import CreditNoteForm from "./CreditNoteForm.component.vue";
export default {
  props: {
    value: Boolean,
    type: String,
    creditNoteId: String,
    projectId: String,
    marketId: String
  },
  components: {
    CreditNoteForm,
  },
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
    };
  },
  methods: {
    dismiss() {
      this.$emit("input", false);
    },
    onSaveSuccess(data) {
      this.$emit("onSaveSuccess", data);
    },
  },
};
</script>
<style lang="scss" scoped>
.card-receipt-form {
  height: calc(100vh - 110px);
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
